module.exports = __webpack_public_path__ + "img/5.0adbc3a2.png";